import { render, staticRenderFns } from "./StatsForm.vue?vue&type=template&id=079adf64&scoped=true"
import script from "./StatsForm.vue?vue&type=script&lang=js"
export * from "./StatsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079adf64",
  null
  
)

export default component.exports